import vue from '../../../main'
import bases from "../../../api/httpApi/base";

let social = {
    copyLink(id) {
        return bases.evi + "/feed/FeedCloud/DisplayVideo?id=" + id;
    },
    reportFunc(item) {
        this.$refs.report.init(item.id, item.sgL_UsersName, 5, null);
    },
    updateStatistics(item, type) {
        if (!item.sgL_IsShare && item.sgL_Type == 0) {
            vue.$message({
                type: "warning",
                message: "數據處理中，請稍後刷新頁面再分享",
            });
            return;
        }
        let params = {};
        params[item.id] = type;
        vue.$api.social.SocialDataUpdateStatistics(params).then((res) => {
            if (res.data.success) {
                if (type == 50) {
                    item.sgL_PG_CTotalShare++;
                }
            } else {
                //this.$message({ type: "error", message: res.data.error.message });
            }
        });
        // console.log(item);
        let urlb = escape(`/Home/facebookResp?id=${item.id}&type=moivecommunity`);
        // console.log(urlb);
        console.log(1111111111, `${vue.$shareUrl}${bases.url}${urlb}`);
        window.open(
            `${vue.$shareUrl}${bases.url}${urlb}`,
            "_blank"
        );
        // window.open(
        //   `https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(bases.url + "" + urlb)}`,
        //   "_blank"
        // );
    },
    async addfavorite(sgL_DevicesType, item, isadd) {
        let params = {
            sgL_DevicesType: sgL_DevicesType,
            sgL_MasterSort: item.sgL_Type, //类型
            sgL_PG_Coid: item.id, //图册、影片、文章、活动的id
            sgL_Fav_FType: 5, //图册：0，图片：1，影片：2,活动：3，新闻文字Id：4，社区：5
            sgL_Fav_FBelongidc: null,
        };
        await vue.$store.dispatch("addfavorite", params).then((res) => {
            if (res) {
                vue.$message({
                  type: "success",
                  message: vue.$t("message.operatesuccessfully")
                });
                if (sgL_DevicesType == 0) {
                    item.sgL_IsFavorite = !item.sgL_IsFavorite;
                } else if (sgL_DevicesType == 1) {
                    if (isadd) {
                        item.sgL_PG_CTotalLike++;
                    } else {
                        if (item.sgL_PG_CTotalLike > 0) {
                            item.sgL_PG_CTotalLike--;
                        }
                    }
                    item.sgL_IsLike = !item.sgL_IsLike;
                } else if (sgL_DevicesType == 3) {
                    item.sgL_IsImpeach = !item.sgL_IsImpeach;
                }
            }
        });
    },
    setPlayerOptions(playerOptions, noChangeVideoList, list, type) {
        for (var i = 0; i < list.length; i++) {
            let posterUrl = (list[i].sgL_ImageTempURL == "" || list[i].sgL_ImageTempURL == null) ? list[i].jietuFileUrl : list[i].sgL_ImageTempURL;
            if (type == 1) {
                this.setPlayer(playerOptions, noChangeVideoList, list[i].id, list[i].fileShareUrl, false, posterUrl);
            } else if (type == 2) {
                this.setPlayer(playerOptions, noChangeVideoList, list[i].moiveCommunityId, list[i].tempUrl, false, posterUrl);
            }
        }
    },
    setPlayer(playerOptions, noChangeVideoList, id, url, isNoChange, posterUrl) {
        let option = {
            playbackRates: [0.5, 1, 2, 3], //播放速度
            autoplay: false, //如果true,浏览器准备好时开始回放。
            muted: false, // 默认情况下将会消除任何音频。
            loop: false, // 导致视频一结束就重新开始。
            preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
            language: "zh-CN",
            aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
            fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
            sources: [
                {
                    type: "video/mp4",
                    src: url + "#t=0.5",
                },
            ],
            poster: posterUrl,
            notSupportedMessage: "此視頻暫無法播放，請稍後再試",
            controlBar: {
                timeDivider: true,
                durationDisplay: true,
                remainingTimeDisplay: false,
                fullscreenToggle: true,
            },
        };
        if (noChangeVideoList.indexOf(id) != -1) {
            return;
        }
        if (isNoChange) {
            noChangeVideoList.push(id);
        }
        playerOptions[id] = option;
    },
};
export default social;


// WEBPACK FOOTER //
// ./src/assets/js/socialJs/tool.js